<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <!-- <div class="back_left" @click="$router.back()"></div> -->
      <div class="big_tit">{{ $t('index.sign') }}</div>
      <!-- <div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div> -->
    </div>
    <div class="login-top">
      <img src="../../../src/assets/images/login/login-top.png" alt="">
    </div>
            <div class="form">
            <div class="login_form_wrapper">
                <div class="input_group">
                    <input 
                        type="text" 
                        v-model="data.username" 
                        :placeholder="$t('user.Username')" 
                        class="form_input"
                    >
                </div>
                <div class="input_group">
                    <input 
                        type="password" 
                        v-model="data.password" 
                        :placeholder="$t('user.Password')" 
                        class="form_input"
                    >
                </div>

                <!-- 提交按钮 -->
                <div 
                    class="submit_btn"
                    :class="data.username == '' || data.password == '' ? 'disabled' : ''"
                    @click="submit"
                >
                    {{ $t('login.submit') }}
                </div>

                <!-- 注册链接 -->
                <div class="register_link">
                    <router-link to="/register">{{ $t('user.NoAccount') }}</router-link>
                </div>
            </div>
        </div>
    
    <!-- <div v-if="config.regmode == '3'" class="basic_btn sbtn" @click="changelogin">
      {{ $t('login.change') }}
    </div> -->
    <!-- <div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
      <img class="kefu_img" src="../images/index/kefu.png" />
    </div> -->
    <div class="login_bottom">
      <img src="../../../src/assets/images/login/login-bottom.png" alt="">
    </div>

    <!-- 底部导航栏 -->
    <FooterTab :activeType="'index'" />
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import { CountDown, Checkbox } from 'vant'
import FooterTab from '../../components/FooterTab.vue'

Vue.use(Checkbox)
import emaillogin from '../../components/emaillogin.vue'
import phonelogin from '../../components/phonelogin.vue'

export default {
  name: "login",
  components: { emaillogin, phonelogin, FooterTab },
  data() {
    return {
      lang: this.$i18n.locale || "zh_hk",

      show_kefu: false,
      msg_show: true,
      showPicker: false,
      countryIndex: 0,
      countryCode: '1',
      checked: true,
      usertype: '',
      data: {
        username: "",
        password: "",
      },
      config: {}
    };
  },
  created() {
    this.data.username = localStorage.getItem('login_username');
    this.data.password = localStorage.getItem('login_password');
    this.$parent.footer("user", false);
  },
  mounted() {
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    // 优先使用App.vue中已加载的配置，减少重复请求
    if (this.$parent.app && this.$parent.app.regmode) {
      this.config = this.$parent.app;
      if (this.config.regmode == '1' || this.config.regmode == '3') {
        this.usertype = 'email';
      } else {
        this.usertype = 'phone';
      }
    } else {
      // 如果没有缓存，则请求
      Fetch('/index/webconfig', {
        type: 'web'
      }).then(res => {
        this.config = res.data;
        if (this.config.regmode == '1' || this.config.regmode == '3') {
          this.usertype = 'email';
        } else {
          this.usertype = 'phone';
        }
      })
    }
  },
  methods: {

    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    changelogin() {
      this.usertype = this.usertype == 'email' ? 'phone' : 'email';
    },
    submit() {
      if (!this.data.username) {
        this.$toast(this.$t('login.phoneEmpty') + this.config.regmode);
        return;
      }

      if (!this.data.password) {
        this.$toast(this.$t('login.passwordEmpty'));
        return;
      }

      // var regex = /^[A-Za-z0-9]{1,20}$/;
      // if (!regex.test(this.data.username)) {
      //     this.$toast(this.$t('login.phoneError'));
      //     return;
      // }

      if (this.checked) {
        localStorage.setItem('login_username', this.data.username);
        localStorage.setItem('login_password', this.data.password);
      }

      if (!this.checked) {
        localStorage.removeItem('login_username');
        localStorage.removeItem('login_password');
      }
      Fetch("/index/login", {
        username: this.data.username,
        password: this.data.password
      })
        .then((res) => {
          console.log('登录响应:', res);
          
          // 检查登录是否成功 - 根据API返回结构判断
          if (res.code !== 1 || !res.data || Object.keys(res.data).length === 0) {
            // 登录失败，显示具体错误信息
            const currentLang = this.$i18n.locale || 'zh_cn';
            let errorMessage;
            
            if (res.info && res.info[currentLang]) {
              // 使用后端返回的多语言错误信息
              errorMessage = res.info[currentLang];
            } else if (res.info) {
              // 使用后端返回的通用错误信息
              errorMessage = res.info;
            } else {
              // 使用默认错误信息
              errorMessage = this.$t('login.loginFailed');
            }
            
            this.$toast({
              background: "#ff4d4f",
              message: errorMessage,
            });
            return; // 不继续执行后续代码
          }
          
          // 登录成功，保存token和用户信息
          if (res.data.token) {
            localStorage.setItem('token', res.data.token);
          }
          
          // 保存用户信息到store
          if (res.data) {
            this.$store.commit('setLogin', res.data);
            // 如果有用户详细信息，也保存到用户信息中
            if (res.data.userInfo) {
              this.$store.commit('setUserInfo', res.data.userInfo);
            }
          }
          
          // 显示成功提示
          this.$toast({
            background: "#07c160",
            message: this.$t('login.signInSuccess'),
          });
          
          // 跳转到目标页面
          const redirectPath = this.$router.history.current.query.redirect;
          let targetPath = "/";
          
          // 如果重定向路径是项目详情页，则跳转到首页或全部产品页
          if (redirectPath && !redirectPath.includes('/projectDetail')) {
            targetPath = redirectPath;
          } else {
            // 如果来源是项目详情页，跳转到全部产品页面
            targetPath = "/allProducts";
          }
          
          this.$router.replace({
            path: targetPath,
          });
        })
        .catch((error) => {
          // 处理真正的网络错误或其他异常
          console.error('登录网络请求失败:', error);
          this.$toast({
            background: "#ff4d4f",
            message: '网络连接失败，请检查网络后重试',
          });
        });
    },
  },
  watch: {
    'data.username': (r) => {
      console.log(r);
    }
  }
};
</script>
<style lang="less" scoped>
.login_bg {
  width: 100%;
  // height: 178px;
  overflow: hidden;
  // background: url(../images/login/login_bg.png) no-repeat center center;
  background-size: 100% 100%;
  color: #323233;

  .language {
    position: absolute;
    top: 4px;
    right: 0;
    height: 36px;

    img {
      height: 100%;
    }
  }

  .big_tit {
    width: 100%;
    height: 30px;
    text-align: center;
    color: #323233;
    font-size: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f5f1f1;
  }
}
.login-top{
    width: 252px;
    height: 160px;
    margin: 0 auto;
    margin-top: 50px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .login_bottom{
    width: 368px;
    height: 272px;
    margin: 0 auto;
    margin-top: 50px;
        img{
      width: 100%;
      height: 100%;
    }
  }

.basic_wrap .form {
    margin: 0 auto;
    width: 90%;
    height: auto;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 0 24px 0 24px;
}

/* 新的登录表单样式 */
.login_form_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
}

.input_group {
    width: 100%;
    margin-bottom: 20px;
}

.form_input {
    width: 100%;
    height: 48px;
    padding: 0 16px;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    background: #f5f5f5;
    box-sizing: border-box;
    color: #333;
    
    &:focus {
        outline: none;
        background: #f0f0f0;
    }
    
    &::placeholder {
        color: #999;
    }
}

.form_options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 24px;
    font-size: 14px;
    
    .reset_pwd {
        color: #1890ff;
        text-decoration: none;
    }
}

.submit_btn {
    width: 100%;
    height: 48px;
    background: #1890ff;
    color: #ffffff;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    transition: background-color 0.3s;
    
    &:hover {
        background: #40a9ff;
    }
    
    &.disabled {
        background: #d9d9d9;
        cursor: not-allowed;
    }
}

.register_link {
    text-align: center;
    
    a {
        color: #1890ff;
        text-decoration: none;
        font-size: 14px;
    }
}

.cut_login {
  width: 207px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  text-align: center;
  margin: 0 auto;

  a {
    width: 50%;
    padding-bottom: 10px;
    color: #ceced0;
    position: relative;

    .line {
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #f2f2f2;
    }
  }

  a.cur {
    color: #f12211;

    .line {
      height: 2px;
      background-image: linear-gradient(to right, #f12211, #f18a11);
    }
  }
}


.item {
  height: 68px;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;

  .icon {
    width: 32px;
    height: 27px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.item_reset_pwd {
  font-size: 14px;
  color: #3d96ff;
  text-align: right;
  margin-top: 10px;
  line-height: 20px;
}

.van-checkbox {
  margin-top: 20px;
}

.reset_pwd {
  color: #3d96ff;
  margin-top: -20px;
  display: block;
}

.basic_btn {
  margin: 39px auto 0 auto;
  background-color: #1989fa !important
}

/* 底部导航栏样式已移至FooterTab组件 */
</style>
